"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
class MeetingDto {
}
exports.MeetingDto = MeetingDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], MeetingDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 29 }),
    tslib_1.__metadata("design:type", Number)
], MeetingDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], MeetingDto.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 343 }),
    tslib_1.__metadata("design:type", Number)
], MeetingDto.prototype, "meetingTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 434 }),
    tslib_1.__metadata("design:type", Number)
], MeetingDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2025-06-20" }),
    tslib_1.__metadata("design:type", String)
], MeetingDto.prototype, "meetingDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2023-10-01T10:00:00.000Z" }),
    tslib_1.__metadata("design:type", String)
], MeetingDto.prototype, "startTime", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2023-10-01T11:00:00.000Z" }),
    tslib_1.__metadata("design:type", String)
], MeetingDto.prototype, "endTime", void 0);
